import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class ExportCompanyDocumentsRequest extends GenericRequest {

    outsourceDocumentsIds;
    workersIds;
    machinesIds;
    monthlyDocumentsIds;
    linkedDocumentsIds;

    constructor(companyId, outsourceDocumentsIds = [], workersIds = [], machinesIds = [], monthlyDocumentsIds = [], linkedDocumentsIds = []) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.COMPANIES_EXPORT, { id: companyId }));

        this.outsourceDocumentsIds = outsourceDocumentsIds;
        this.workersIds = workersIds;
        this.machinesIds = machinesIds;
        this.monthlyDocumentsIds = monthlyDocumentsIds;
        this.linkedDocumentsIds = linkedDocumentsIds;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        request.criteria.workers = this.workersIds;
        request.criteria.machines = this.machinesIds;
        request.criteria.company_documents = this.outsourceDocumentsIds;
        request.criteria.monthly_documents = this.monthlyDocumentsIds;
        request.criteria.linked_documents = this.linkedDocumentsIds;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/outsource/ws/ExportCompanyDocumentsRequest.js